import React from 'react'

//
import Image from 'next/image'

// TODO: expand this if design or visual is final (inline playing video for example)
const OrderIntegrationVisual = ({ image = '' }) => {
  return <Image src={image} />
}

export default OrderIntegrationVisual
